import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { LoaderService } from '@shared/async-services/loader/loader.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnInit {
  constructor(
    public loaderService: LoaderService,
    private ngxUiLoaderService: NgxUiLoaderService
  ) { }

  ngOnInit(): void {
  }

}
